import { uniq } from 'ramda';
import { compact } from '@moda/portal-stanchions';
import { usePreferredRegion, groupSizesByRegion, getSizeRegion } from '../SizeGuide';

export const usePreferredRegionSizeEquivalents = (
  sizeEquivalents: string[][],
  size: string | null
) => {
  const productSizeRegion = getSizeRegion(size);
  const preferredRegion = usePreferredRegion();

  const sizesByRegion = sizeEquivalents.map(groupSizesByRegion);

  if (!size) return [];

  return compact(
    uniq(
      sizesByRegion
        .filter(sizes =>
          sizes[productSizeRegion]?.some(
            originalSize => originalSize === size || originalSize.split('/').includes(size)
          )
        )
        .map(sizes => sizes[preferredRegion.name])
        .flat()
    )
  );
};
